import { Grid } from "@material-ui/core";
import { CustomLoading } from "../../../assets/icons/GIFIcons";
import { Title } from "./style";

interface IPropsLoading {
  /** Mensagem do estado */
  message: string;
}

/** Etapa com loading.
 * @category Components
 */
const LoadingLayer = (props: IPropsLoading) => {
  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
    >
      <Grid item>
        <CustomLoading />
      </Grid>
      <Grid item>
        <Title>{props.message}</Title>
      </Grid>
    </Grid>
  );
};

export default LoadingLayer;
